import React from "react";
import ItemContainerShared from "shared/itemLists/items/ItemContainer.shared";
import { sortableElement } from "react-sortable-hoc";

const SortableItem = sortableElement((props) => (
  <ItemContainerShared {...props} />
));

export default function TodayBubble({ dueItemCollection, dateHelper, index }) {
  return (
    <SortableItem
      collection={dueItemCollection}
      index={index}
      disabled={true}
      details={dateHelper.todayDetails()}
    />
  );
}
